const predefinedEvents = new Map([
    [
        'Purchase_Paid_Facebook',
        {
            name: 'Purchase_Paid_Facebook',
        },
    ],
    [
        'Purchase_Paid_Google',
        {
            name: 'Purchase_Paid_Google',
        },
    ],
    [
        'Purchase_Paid_Bing',
        {
            name: 'Purchase_Paid_Bing',
        },
    ],
    [
        'Purchase_Paid_TikTok',
        {
            name: 'Purchase_Paid_TikTok',
        },
    ],
    [
        'Purchase_Paid_Snap',
        {
            name: 'Purchase_Paid_Snap',
        },
    ],
    [
        'Purchase_Paid_Twitter',
        {
            name: 'Purchase_Paid_Twitter',
        },
    ],
    [
        'Purchase_Paid_Other',
        {
            name: 'Purchase_Paid_Other',
        },
    ],
    [
        'Purchase_Other_Referral',
        {
            name: 'Purchase_Other_Referral',
            dependencies: new Set([
                'Purchase_Organic_Google',
                'Purchase_Organic_Bing',
                'Purchase_Search_Other',
            ]),
        },
    ],
    [
        'Purchase_Organic_Google',
        {
            name: 'Purchase_Organic_Google',
        },
    ],
    [
        'Purchase_Organic_Bing',
        {
            name: 'Purchase_Organic_Bing',
        },
    ],
    [
        'Purchase_Search_Other',
        {
            name: 'Purchase_Search_Other',
        },
    ],
    [
        'Purchase_Other',
        {
            name: 'Purchase_Other',
            dependencies: new Set(['Purchase_Other_Referral']),
        },
    ],
    [
        'Purchase_AppLovin',
        {
            name: 'Purchase_AppLovin',
        },
    ],
    [
        'Purchase_Retail',
        {
            name: 'Purchase_Retail',
        },
    ],
    [
        'Purchase_Offline',
        {
            name: 'Purchase_Offline',
        },
    ],
    [
        'Paid_Social_NonFB',
        {
            name: 'Paid_Social_NonFB',
            dependencies: new Set(['Purchase_Paid_TikTok', 'Purchase_AppLovin']),
            description: 'Triggered when a TikTok or AppLovin event is generated',
        },
    ],
    [
        'Purchase_Google',
        {
            name: 'Purchase_Google',
            dependencies: new Set(['Purchase_Paid_Google', 'Purchase_Paid_Bing']),
            description: 'Triggered when a Google or Bing event is generated',
        },
    ],
    [
        'Purchase_Organic',
        {
            name: 'Purchase_Organic',
            dependencies: new Set([
                'Purchase_Organic_Google',
                'Purchase_Organic_Bing',
            ]),
            description: 'Triggered when a Google or Bing search event is generated',
        },
    ],
    [
        'Purchase_Custom_Other',
        {
            name: 'Purchase_Custom_Other',
            dependencies: new Set([
                'Purchase_Paid_Other',
                'Purchase_Other_Referral',
                'Purchase_Search_Other',
                'Purchase_Other',
            ]),
            description: 'Triggered when other purchase events occur',
        },
    ],
    [
        'Purchase_Direct',
        {
            name: 'Purchase_Direct',
            dependencies: new Set([
                'Purchase_Paid_Facebook',
                'Purchase_Paid_Google',
                'Purchase_Paid_Bing',
                'Purchase_Paid_TikTok',
                'Purchase_Paid_Snap',
                'Purchase_Paid_Twitter',
                'Purchase_Paid_Other',
                'Purchase_Other_Referral',
                'Purchase_Organic_Google',
                'Purchase_Organic_Bing',
                'Purchase_Search_Other',
                'Purchase_Other',
                'Purchase_AppLovin',
                'Purchase_Retail',
                'Purchase_Offline',
            ]),
        },
    ],
]);
const sortConfigs = (a, b) => {
    var _a, _b, _c, _d, _e, _f;
    if ((_a = a.dependencies) === null || _a === void 0 ? void 0 : _a.has(b.name)) {
        return 1;
    }
    else if ((_b = b.dependencies) === null || _b === void 0 ? void 0 : _b.has(a.name)) {
        return -1;
    }
    return ((_d = (_c = a.dependencies) === null || _c === void 0 ? void 0 : _c.size) !== null && _d !== void 0 ? _d : 0) - ((_f = (_e = b.dependencies) === null || _e === void 0 ? void 0 : _e.size) !== null && _f !== void 0 ? _f : 0);
};
const encode = (configuration) => JSON.stringify([...configuration]
    .sort(sortConfigs)
    .filter((n) => !defaultComputedEvents.has(n.name))
    .map((entry) => {
    const deps = entry.dependencies && entry.dependencies.size > 0
        ? [...entry.dependencies]
        : undefined;
    return { n: entry.name, d: deps };
}));
const defaultComputedEvents = new Set([
    'Purchase_Paid_Facebook',
    'Purchase_Paid_Google',
    'Purchase_Paid_Bing',
    'Purchase_Paid_TikTok',
    'Purchase_Paid_Snap',
    'Purchase_Paid_Twitter',
    'Purchase_Paid_Other',
    'Purchase_Direct',
    'Purchase_Other_Referral',
    'Purchase_Organic_Google',
    'Purchase_Organic_Bing',
    'Purchase_Search_Other',
    'Purchase_Other',
    'Purchase_AppLovin',
    'Purchase_Retail',
    'Purchase_Offline',
]);
encode([...defaultComputedEvents].map((n) => predefinedEvents.get(n)));

const packageName = 'facebook';
const sdkUrl = 'https://connect.facebook.net/en_US/fbevents.js';

const getFbq = () => {
    if (!window || !window.fbq) {
        return null;
    }
    return window.fbq;
};
const getUserData = () => {
    var _a;
    const data = {};
    try {
        const user = (_a = JSON.parse(window.sessionStorage.getItem('_workerStore') || '{}')) === null || _a === void 0 ? void 0 : _a.kv;
        if (!user) {
            return data;
        }
        if (user.email) {
            data['em'] = user.email;
        }
        if (user.phone) {
            data['ph'] = user.phone;
        }
        if (user.firstName) {
            data['fn'] = user.firstName;
        }
        if (user.lastName) {
            data['ln'] = user.lastName;
        }
        if (user.city) {
            data['ct'] = user.city;
        }
        if (user.state) {
            data['st'] = user.state;
        }
        if (user.country) {
            data['country'] = user.country;
        }
    }
    catch (e) {
        console.error(e);
    }
    return data;
};
const runInit = (pixelId, ldu, userId) => {
    var _a, _b;
    const wrapper = getFbq();
    if (!wrapper) {
        return;
    }
    if ((_b = (_a = wrapper.instance) === null || _a === void 0 ? void 0 : _a.pixelsByID) === null || _b === void 0 ? void 0 : _b[pixelId]) {
        wrapper.instance.pixelsByID[pixelId].userData = null;
    }
    wrapper('init', pixelId, {
        external_id: userId,
        ...getUserData(),
    });
    wrapper.disablePushState = true;
    if (ldu) {
        wrapper('dataProcessingOptions', ['LDU'], 0, 0);
    }
};

// eslint-disable-next-line @nx/enforce-module-boundaries
const snippet = () => {
    if (!window || !document || window.fbq) {
        return;
    }
    const n = (window.fbq = function () {
        n['callMethod']
            ? // eslint-disable-next-line prefer-spread,prefer-rest-params
                n['callMethod'].apply(n, arguments)
            : // eslint-disable-next-line prefer-rest-params
                n['queue'].push(arguments);
    });
    if (!window._fbq) {
        window._fbq = n;
    }
    n['push'] = n;
    n['loaded'] = !0;
    n['version'] = '2.0';
    n['queue'] = [];
    const element = document.createElement('script');
    element.async = !0;
    element.src = sdkUrl;
    const script = document.getElementsByTagName('script')[0];
    if (script && script.parentNode) {
        script.parentNode.insertBefore(element, script);
    }
};
const init = ({ manifest, userId }) => {
    if (!manifest.variables ||
        !manifest.variables['pixelId'] ||
        manifest.variables['enableBrowser'] !== '1') {
        return;
    }
    snippet();
    runInit(manifest.variables['pixelId'], manifest.variables['ldu'] === '1', userId);
};

const getProductIdFromMapping = (item, productIdMapping) => {
    if (productIdMapping === '1' && item['variantId']) {
        return item['variantId'];
    }
    if (productIdMapping === '2' && item['sku']) {
        return item['sku'];
    }
    return item['id'];
};

const getProductMappingModel = (productIdMapping, useVariantId) => {
    const value = productIdMapping || useVariantId || '0';
    return (value && /^[012]$/.test(value) ? value : '0');
};
const prepareData = (data, productIdMapping) => {
    const payload = {
        app: 'Blotout',
    };
    if (data['value'] || data['value'] === 0) {
        payload['value'] = data['value'];
    }
    if (data['currency']) {
        payload['currency'] = data['currency'];
    }
    if (data['name']) {
        payload['content_name'] = data['name'];
    }
    if (data['type']) {
        payload['content_type'] = data['type'];
    }
    if (data['category']) {
        payload['content_category'] = data['category'];
    }
    if (data['ids']) {
        payload['content_ids'] = data['ids'];
    }
    if (data['search']) {
        payload['search_string'] = data['search'];
    }
    if (data['status']) {
        payload['status'] = data['status'];
    }
    if (data['predicted_ltv']) {
        payload['predicted_ltv'] = data['predicted_ltv'];
    }
    if (data['orderId']) {
        payload['order_id'] = data['orderId'];
    }
    if (data['contents'] && Array.isArray(data['contents'])) {
        payload['contents'] = data['contents'].map((item) => {
            const content = {};
            const contentId = getProductIdFromMapping(item, productIdMapping);
            if (contentId) {
                content['id'] = contentId;
            }
            if (item.quantity) {
                content['quantity'] = item.quantity;
            }
            if (item.item_price || item.item_price === 0) {
                content['item_price'] = item.item_price;
            }
            if (item.category) {
                content['category'] = item.category;
            }
            if (item.title) {
                content['title'] = item.title;
            }
            return content;
        });
        if (data['contents'] && data['contents'][0] && data['contents'][0].type) {
            payload['content_type'] = data['contents'][0].type;
        }
    }
    if (data['contents'] || data['ids']) {
        const contents = data['contents'] || data['ids'];
        if (Array.isArray(contents)) {
            payload['num_items'] = contents.length;
        }
    }
    return payload;
};
const tag = ({ data, eventName, manifestVariables, eventId }) => {
    const payload = {
        sdkVersion: "1.17.0" ,
    };
    if (window.fbq &&
        !!manifestVariables['pixelId'] &&
        manifestVariables['enableBrowser'] === '1') {
        const eventData = data['skipTransformation'] === true
            ? data
            : prepareData(data, getProductMappingModel(manifestVariables['productIdMapping'], manifestVariables['variantId']));
        delete eventData['skipTransformation'];
        window.fbq('trackSingle', manifestVariables['pixelId'], eventName, eventData, {
            eventID: eventId,
        });
    }
    return payload;
};

const user = ({ userId, manifestVariables }) => {
    if (!manifestVariables ||
        !manifestVariables['pixelId'] ||
        manifestVariables['enableBrowser'] !== '1') {
        return;
    }
    runInit(manifestVariables['pixelId'], manifestVariables['ldu'] === '1', userId);
};

// eslint-disable-next-line @nx/enforce-module-boundaries
const data = {
    name: packageName,
    tag,
    init,
    user,
};
try {
    if (window) {
        if (!window.edgetagProviders) {
            window.edgetagProviders = [];
        }
        window.edgetagProviders.push(data);
    }
}
catch {
    // No window
}

export { data as default };
